import React from 'react';
import {
  ReactCompareSlider,
  ReactCompareSliderImage
} from 'react-compare-slider';

export default function BeforeAfterComparison({ beforeImage, afterImage, alt }) {
  return (
    <div 
      className="relative rounded-xl overflow-hidden border" 
      style={{ borderColor: 'var(--hr-border)' }}
      data-testid="before-after-slider"
    >
      <ReactCompareSlider
        itemOne={
          <ReactCompareSliderImage
            src={beforeImage}
            alt={`Avant - ${alt}`}
            style={{ objectFit: 'cover' }}
          />
        }
        itemTwo={
          <ReactCompareSliderImage
            src={afterImage}
            alt={`Après - ${alt}`}
            style={{ objectFit: 'cover' }}
          />
        }
        position={50}
        className="h-[300px] sm:h-[350px]"
      />
      
      {/* Labels avant/après */}
      <div className="absolute top-3 left-3 z-10">
        <div 
          className="px-3 py-1.5 rounded-full text-xs font-['Montserrat'] font-medium uppercase tracking-wide backdrop-blur-sm"
          style={{ 
            backgroundColor: 'rgba(43,43,43,0.7)', 
            color: 'var(--hr-bg)' 
          }}
        >
          Avant
        </div>
      </div>
      
      <div className="absolute top-3 right-3 z-10">
        <div 
          className="px-3 py-1.5 rounded-full text-xs font-['Montserrat'] font-medium uppercase tracking-wide backdrop-blur-sm"
          style={{ 
            backgroundColor: 'rgba(95,103,80,0.9)', 
            color: 'var(--hr-primary-fg)' 
          }}
        >
          Après
        </div>
      </div>
    </div>
  );
}